<div *transloco="let t" class="top-mover-wrapper">
  <div class="interval-date-picker">
    <xi-date-picker
      [placeholder]="t('widgets.selected-interval-date')"
      [dateValue]="modelDateTopFrom"
      (onDateChange)="updateSelectedDate($event.detail.date)"
    ></xi-date-picker>

    <button
      mat-icon-button
      #minimumOccurancePopover="ngbPopover"
      (click)="openMinimumOccurrencesPopover(minimumOccurancePopover)"
      [ngbPopover]="minimumOccuranceTemplate"
      popoverClass="minimum-occurrences-popover"
      placement="bottom"
      triggers="manual"
      [container]="'body'"
      [autoClose]="'outside'"
      class="minimum-occurrences-button"
    >
      <div class="minimum-occurrences-menu__label">
        {{ minimumOccurences }}
      </div>
    </button>
  </div>

  @if (isLoading) {
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
  }
  @if (!isLoading) {
    <div class="top-mover-table-wrapper">
      @if (dataSource.isDataSourceNotFound) {
        <div>
          <div class="text-center">
            <h1>{{ t('widgets.data-source-removed-select-another') }}</h1>
          </div>
        </div>
      }
      @if (hasInvalidComparison) {
        <div class="text-center">
          <h1>{{ t('widgets.has-invalid-comparison') }}</h1>
        </div>
      }
      @if (!dataSource.isDataSourceNotFound && !hasInvalidComparison) {
        <table mat-table [dataSource]="dataSource" class="top-mover-table">
          <tr mat-header-row *matHeaderRowDef="dataSource.displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: dataSource.displayedColumns"></tr>
          <ng-container matColumnDef="featureName">
            <th mat-header-cell *matHeaderCellDef>{{ t('widgets.datatable.mover-name') }}</th>
            <td mat-cell matTooltipPosition="above" *matCellDef="let mover">
              {{ mover.featureName | truncate: 25 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="intervalPercentDiff">
            <th mat-header-cell *matHeaderCellDef class="sentiment interval-header">
              {{ t('widgets.datatable.interval-percentage-change') }}
            </th>
            <td
              mat-cell
              *matCellDef="let mover"
              class="sentiment"
              [ngClass]="{
                'positive-entry': positive(mover.intervalPercentDiff),
                'negative-entry': negative(mover.intervalPercentDiff),
              }"
            >
              @if (arrowIcon(mover.intervalPercentDiff)) {
                <mat-icon>
                  {{ arrowIcon(mover.intervalPercentDiff) }}
                </mat-icon>
              }
              {{ mover.intervalPercentDiff }}%
            </td>
          </ng-container>
          <ng-container matColumnDef="intervalSentimentDiff">
            <th mat-header-cell *matHeaderCellDef class="last-updated">
              {{ t('widgets.interval-sentiment-change') }}
            </th>
            <td
              mat-cell
              *matCellDef="let mover"
              class="sentiment"
              [ngClass]="{
                'positive-entry': positive(mover.intervalSentimentDiff),
                'negative-entry': negative(mover.intervalSentimentDiff),
              }"
            >
              @if (arrowIcon(mover.intervalSentimentDiff)) {
                <mat-icon>
                  {{ arrowIcon(mover.intervalSentimentDiff) }}
                </mat-icon>
              }
              {{ mover.intervalSentimentDiff | number: '1.2-2' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="featureDocumentHits">
            <th mat-header-cell *matHeaderCellDef class="text">
              {{ t('widgets.mover-document-hits') }}
            </th>
            <td mat-cell *matCellDef="let mover" class="sentiment">
              {{ mover.featureDocumentHits }}
            </td>
          </ng-container>
          <ng-container matColumnDef="longIntervalPercentDiff">
            <th mat-header-cell *matHeaderCellDef class="sentiment">
              {{ t('widgets.secondary-interval-percentage-change') }}
            </th>
            <td
              mat-cell
              *matCellDef="let mover"
              class="sentiment"
              [ngClass]="{
                'positive-entry': positive(mover.longIntervalPercentDiff),
                'negative-entry': negative(mover.longIntervalPercentDiff),
              }"
            >
              @if (arrowIcon(mover.longIntervalPercentDiff)) {
                <mat-icon>
                  {{ arrowIcon(mover.longIntervalPercentDiff) }}
                </mat-icon>
              }
              {{ mover.longIntervalPercentDiff }}%
            </td>
          </ng-container>
          <ng-container matColumnDef="longIntervalSentimentDiff">
            <th mat-header-cell *matHeaderCellDef class="last-updated">
              {{ t('widgets.secondary-interval-sentiment-change') }}
            </th>
            <td
              mat-cell
              *matCellDef="let mover"
              [ngClass]="{
                'positive-entry': positive(mover.longIntervalSentimentDiff),
                'negative-entry': negative(mover.longIntervalSentimentDiff),
              }"
              class="sentiment"
            >
              @if (arrowIcon(mover.longIntervalSentimentDiff)) {
                <mat-icon>
                  {{ arrowIcon(mover.longIntervalSentimentDiff) }}
                </mat-icon>
              }
              {{ mover.longIntervalSentimentDiff | number: '1.2-2' }}
            </td>
          </ng-container>
        </table>
      }
    </div>
  }

  <ng-template #minimumOccuranceTemplate let-popover>
    <div class="minimum-occurrences-popover">
      <div class="minimum-occurrences-popover__header">{{ t('widgets.minimum-occurrences') }}</div>

      <div class="minimum-occurrences-popover__content">
        <!-- TODO: The 'tickInterval' property no longer exists -->
        <xi-slider
          [min]="1"
          [max]="20"
          [increment]="1"
          [value]="minimumOccurences"
          (onSliderChange)="closeMinimumOccurrencesPopover($event.detail.value, popover)"
        ></xi-slider>

        <input
          [(ngModel)]="minimumOccurences"
          class="minimum-occurrences-popover__limit-input"
          disabled
        />
      </div>
    </div>
  </ng-template>
</div>
